export default "__VITE_ASSET__BuJX9ezr__"